/**
 * components/clients/MatchConfidenceBadge.tsx
 *
 * Displays a confidence level badge (Forte / Moyenne / Faible) for client match candidates.
 * Created Apr 2026.
 */

interface MatchConfidenceBadgeProps {
  confidence: number;
  reasons: string[];
}

export default function MatchConfidenceBadge({ confidence, reasons }: MatchConfidenceBadgeProps) {
  let label: string;
  let className: string;

  if (confidence >= 80) {
    label = 'Correspondance forte';
    className = 'bg-success-50 text-success-700 border border-success-200';
  } else if (confidence >= 40) {
    label = 'Correspondance moyenne';
    className = 'bg-amber-50 text-amber-700 border border-amber-200';
  } else {
    label = 'Correspondance faible';
    className = 'bg-neutral-100 text-neutral-600 border border-neutral-200';
  }

  return (
    <div className="flex flex-col gap-1">
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${className}`}>
        {label}
      </span>
      {reasons.length > 0 && (
        <p className="text-xs text-neutral-400">{reasons.join(' · ')}</p>
      )}
    </div>
  );
}
